import { render } from "./DiagramView.vue?vue&type=template&id=8ef260e8"
import script from "./DiagramView.vue?vue&type=script&lang=js"
export * from "./DiagramView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__